import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import Amplify, {Auth} from 'aws-amplify';
import MainSideBar from './components/universal/mainSideBar/mainSideBar.js';
import Content from './components/content/content.js';
import './App.css';

if (process.env.NODE_ENV === 'development') import('./Debug.css');

const apiStage = process.env.REACT_APP_STAGE === 'development' ? 'beta' : 'prod';

Amplify.configure({
  Auth: {
    identityPoolId: 'eu-west-1:10c83c79-25a3-488d-a1c8-54c3f3c655e1',
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_LnW7KU6ir',
    mandatorySignIn: true,
    userPoolWebClientId: '77hnsa06l44unbdu74c87s6s2q'
  },
  API: {
    endpoints: [
      {
        name: 'WBU',
        endpoint: `https://7cv01vcfij.execute-api.eu-west-1.amazonaws.com/${apiStage}`,
        region: 'eu-west-1'
      },
      {
        name: 'HSI',
        endpoint: `https://7lcn1purjj.execute-api.eu-west-1.amazonaws.com/${apiStage}`,
        region: 'eu-west-1'
      }
    ]
  },
  Storage: {
    bucket: 'weaveability-basis-utilities-storage',
    region: 'eu-west-1'
  }
});

class App extends Component {

  state = {
    loggedIn: true,
    userGroups: []
  }

  componentDidMount() {
    this.checkUsersGroup();
  }

  checkUsersGroup = () => {
    Auth.currentAuthenticatedUser()
    .then(res => {
      const userGroups = res.signInUserSession.accessToken.payload['cognito:groups'];
      const loggedIn = userGroups.length > 0 ? true : false;
      this.setState({userGroups, loggedIn});
    })
    .catch(err => {
      this.setState({userGroups: [], loggedIn: false});
    })
    .catch(err => {
      console.log(err);
    });
  }

  render() {

    return (
      <Router>
        <div className="App">
          <MainSideBar userGroups={this.state.userGroups}/>
          <Content checkUsersGroup={this.checkUsersGroup} loggedIn={this.state.loggedIn}/>
        </div>
      </Router>
    );

  }

}

export default App;


// WEBPACK FOOTER //
// ./src/App.js